import { Component, Input, OnInit, inject } from '@angular/core';
import { CardModule } from 'primeng/card';
import { TagModule } from 'primeng/tag';
import { Election } from '../../../../core/interfaces/election';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'primeng/popover';
import { DividerModule } from "primeng/divider";
import { TooltipModule } from 'primeng/tooltip';
import { ProgressBar } from 'primeng/progressbar';
import { CampaignResultPipe } from '../../../../shared/pipes/campaign-result.pipe';
import { CampaignAction, PermissionService } from '../../../../core/services/permission.service';

@Component({
  selector: 'app-election-card',
  imports: [CardModule, TagModule, ButtonModule, RouterModule, CommonModule, PopoverModule, DividerModule, TooltipModule, ProgressBar, CampaignResultPipe],
  templateUrl: './election-card.component.html',
  styleUrl: './election-card.component.scss'
})
export class ElectionCardComponent implements OnInit {
  @Input( ) election!: Election;
  daysRemaining!: number | null
  timelineProgress!: number
  /** Which quick links to show for this card's campaign (spec 004, FR-020). */
  can: Partial<Record<CampaignAction, boolean>> = {};
  private permissions = inject(PermissionService);

  ngOnInit(): void {
      this.permissions.canAll$(['viewDashboard', 'viewReports', 'viewGroups', 'upload',
        'manageCampaignUsers', 'editCampaignDetails', 'viewDetails'], this.election.id)
        .subscribe(can => this.can = can);
      this.daysRemaining = this.calculateDaysRemaining(new Date(this.election.endDate!))
      this.timelineProgress = this.calculateTimelineProgress(new Date(this.election.startDate!), new Date(this.election.endDate!))
  }

  calculateDaysRemaining(targetDate: Date) {
    const now = new Date();
    const difference = new Date(targetDate).getTime() - now.getTime();
    return Math.ceil(difference / (1000 * 60 * 60 * 24));
  }

  calculateTimelineProgress(startDate: Date, endDate: Date): number {
    const now = new Date();
    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();
    const total = end - start;
    if (total <= 0) return 100;
    const elapsed = now.getTime() - start;
    return Math.min(100, Math.max(0, Math.round((elapsed / total) * 100)));
  }

  get formattedType(): string {
    if (!this.election?.type) return '';
    return this.election.type
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, c => c.toUpperCase());
  }


}
